import React, { useEffect } from 'react'

import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { CalendarEventForm } from './CalendarEventForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'
import axiosClient from '../service/axiosClient'

export const CalendarEditPage = () => {
    const {t} = useTranslation()
    const params = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (isNaN(parseInt(params.id as string)) || parseInt(params.id as string) <= 0) {
            navigate('/app/calendar')
        }
    }, [params.id])

    async function deleteEvent() {
        if (confirm(t('confirm_delete_event'))) {
            await axiosClient.delete('calendar-event/' + params.id)
            toast.success(t('event_deleted_success'))
            navigate('/app/calendar')
        }
    }

    return (
        <AppLayout>
            <AppTitle append={
                <div><Link to={'/app/calendar'}>
                    <button className="btn amani-primary">{t('back')}</button>
                </Link>
                    <button className="btn amani-primary ms-2" onClick={deleteEvent}>{t('delete')}</button>
                </div>}>
                {/*Udalosť #{params.id}*/}
            </AppTitle>

            <CalendarEventForm id={parseInt(params.id as string)}/>
        </AppLayout>
    )
}